import axios from 'axios'
import { Message } from 'element-ui'
import store from 'src/store'
import { getToken } from 'src/utils/auth'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})

// 文档中的统一设置post请求头。下面会说到post请求的几种'Content-Type'
service.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

let httpCode = {
    400: '请求参数错误',
    401: '权限不足, 请重新登录',
    403: '服务器拒绝本次访问',
    404: '请求资源未找到',
    405: 'Method Not Allowed',
    500: '内部服务器错误',
    501: '服务器不支持该请求中使用的方法',
    502: '网关错误',
    504: '网关超时'
}

/** 添加请求拦截器 **/
service.interceptors.request.use(config => {
    if (store.getters.token) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        config.headers['Authorization'] = getToken()
    }

    if (config.params) { // 添加时间戳参数，防止浏览器（IE）对get请求的缓存
        config.params = {
            ...config.params,
            t: new Date().getTime()
        }
    }

    // 在这里：可以根据业务需求可以在发送请求之前做些什么:例如我这个是导出文件的接口，因为返回的是二进制流，所以需要设置请求响应类型为blob，就可以在此处设置。
    if (config.url.includes('/export')) {
        config.headers['responseType'] = 'blob'
    }
    // 我这里是文件上传，发送的是二进制流，所以需要设置请求头的'Content-Type'
    if (config.url.includes('Upload')) {
        config.headers['Content-Type'] = 'multipart/form-data'
    }
    return config
}, error=> {
    // 对请求错误做些什么
    return Promise.reject(error)
})

/** 添加响应拦截器  **/
service.interceptors.response.use(response => {

    console.log(response)
    if (response.status === 200) {
        const res = response.data
        if(Object.prototype.hasOwnProperty.call(res,'errorCode'))
        {
            if(res['errorCode'] === 3001 || res['errorCode'] === 3002 || res['errorCode'] === 3003)
            {
                // to re-login
                /*MessageBox.confirm(res['errorMsg'], 'Confirm token', {
                    confirmButtonText: 'Re-Login',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('user/resetToken').then(() => {
                        location.reload()
                    })
                })*/
                store.dispatch('user/resetToken').then(() => {
                    location.reload()
                })
            }
        }
        return Promise.resolve(response.data)
    } else {
        return Promise.reject(response.data.message)
    }
}, error => {

    console.log(error.response)
    if (error.response) {

        // 根据请求失败的http状态码去给用户相应的提示
        let tips = error.response.status in httpCode ? httpCode[error.response.status] : error.response.data
        Message({
            message: tips,
            type: 'error',
            duration: 5 * 1000
        })

        return Promise.reject(error)
    } else {
        Message({
            message: '请求超时, 请刷新重试',
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(new Error('请求超时, 请刷新重试'))
    }
})

/* 统一封装get请求 */
export const get = (url, params, config = {}) => {
    return new Promise((resolve, reject) => {
        service({
            method: 'get',
            url,
            params,
            ...config
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/* 统一封装post请求  */
export const post = (url, data, params, config = {}) => {
    return new Promise((resolve, reject) => {
        service({
            method: 'post',
            url,
            data,
            params,
            ...config
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
